import React, { Component, useState } from 'react';
import {
  Media,
  ListGroup,
  Button,
  Input,
  FormGroup,
} from 'reactstrap';

import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import "react-tabs/style/react-tabs.css";
import Checkout from './checkout';
import { firebase } from './utils/firebase';
import { FirestoreCollection, FirestoreDocument } from 'react-firestore';
import { Step2, Step3 } from './components/animalAccountRegistration';
import { Step2 as BusinessStep2 } from './components/businessAccountRegistration';
import {Link} from 'react-router-dom';
import imageCompression from 'browser-image-compression';
import ReactTable from 'react-table';
import 'react-table/react-table.css';
import ReactExport from 'react-export-excel';
import { BarLoader } from 'react-spinners';

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;
const ExcelExportColumnGroup = ReactExport.ExcelFile.ExcelExportColumnGroup;
//import { resolveSrv } from 'dns';


var columns = [{
  Header: 'Time',
  accessor: 'scanDate', // String-based value accessors!
}, {
  Header: 'Name',
  accessor: 'name',
}, {
  Header: 'Action', // Required because our accessor is not a string
  accessor: 'eventType',
}, {
  Header: 'Notes', // Custom header components!
  accessor: 'comment',
}, {
  Header: 'Valid', // Custom header components!
  accessor: 'validForBusiness',
}, {
  Header: 'Owner',
  accessor: 'owner',
}, {
  Header: 'Phone',
  accessor: 'phone',
}, {
  Header: 'Latitude',
  accessor: 'latitude',
}, {
  Header: 'Longitude',
  accessor: 'longitude',
}]

var header2 = [
  {
    value: "Headings",
    widthPx: 160,
    style: { font: { sz: "24", bold: true } },
  },
  {
    value: "Text Style",
    widthPx: 180,
    style: { font: { sz: "24", bold: true } },
  },
  {
    value: "Colors",
    style: { font: { sz: "24", bold: true } }, // if no width set, default excel column width will be used ( 64px )
  },
]

var paymentColumns = [{
  Header: 'Date',
  accessor: 'readableTime' // String-based value accessors!
}, {
  Header: 'Amount',
  accessor: 'price',
}, {
  Header: 'From', // Required because our accessor is not a string
  accessor: 'name',
},{
  Header: 'Comments', // Required because our accessor is not a string
  accessor: 'comments',
},
{
  Header: 'Email', // Required because our accessor is not a string
  accessor: 'email',
},
{
  Header: 'Phone', // Required because our accessor is not a string
  accessor: 'phone',
}]


export default class Profile extends Component {
  constructor() {
    super()

    this.state = {
      isSignedIn: false,
      userProfile: null,
      pageLoading: true,
      userEmail: '',
      isCanineBreedToggled: false,
      isCanineVaccineToggled: false,
      isFelineBreedToggled: false,
      isFelineVaccineToggled: false,
      animals: [],
      startDate: (new Date(Date.now()).toLocaleDateString("fr-CA")),
      endDate: (new Date(Date.now()).toLocaleDateString("fr-CA")),
      file: null,
      veterinaryHealthCertificate: null,
      fileSN: null,
      invalidProfile: false,
      animalToAddTagsFor: 0,
      numberOfTags: 1,
      esaFile: null,
      dogImage: null,
      dogImageBlob: null,
      profilePicture: null,
      priceToPay: 31.95,
      businessId: "0OUfh4hkZ0e6vSRtt29ierFqU512",
      businessName: "Denver Pet Expo",
      profilePictureBlob: null,
      isLoadingAnimalInfo: true,
      isProfileEditing: false,
      isProfileEditingUser: false,
      isProfileEditingAnimal: false,
      isBusinessProfileEditing: false,
      animalInfo: {},
      gotAnimalDocs: false,
      scanInfo: null,
      expand: false,
      gotProfileInfo: false,
      gotAnimalInfo: false,
      setTo: [],
      scanInfoLoading: false,
      businessPaymentsComments: "",
      business: [],
      businessTabSetting: "payment",
      animalExists: false,
      animalIdRequested: 0,
      animalNameRequested:"",
    }

    this.canineBreedToggle = this.canineBreedToggle.bind(this);
    this.canineVaccineToggle = this.canineVaccineToggle.bind(this);
    this.felineBreedToggle = this.felineBreedToggle.bind(this);
    this.felineVaccineToggle = this.felineVaccineToggle.bind(this);
    this.onProfileHandleChange = this.onProfileHandleChange.bind(this);
    this.onHandleChange = this.onHandleChange.bind(this);
    this.onAnimalProfileHandleChange = this.onAnimalProfileHandleChange.bind(this);
    this.onBusinessProfileHandleChange = this.onBusinessProfileHandleChange.bind(this);
    this.handleProfileUploadCompression = this.handleProfileUploadCompression.bind(this);
    this.uploadVaccinations = this.uploadVaccinations.bind(this);
    this.uploadSpayNeuter = this.uploadSpayNeuter.bind(this);
    this.uploadProfileImage = this.uploadProfileImage.bind(this);
    this.uploadESANote = this.uploadESANote.bind(this);
    this.uploadLicense = this.uploadLicense.bind(this);
    this.uploadVetHealthCertificate = this.uploadVetHealthCertificate.bind(this);
    this.uploadDogImage = this.uploadDogImage.bind(this);
    this.toggleProfileEditingUser = this.toggleProfileEditingUser.bind(this);
    this.toggleProfileEditingAnimal = this.toggleProfileEditingAnimal.bind(this);
    this.transferPet = this.transferPet.bind(this);
    this.orderNewtag = this.orderNewtag.bind(this);
    this.setNumTags = this.setNumTags.bind(this);
    this.paidSuccessfully = this.paidSuccessfully.bind(this);
    this.directPaymentToBusiness = this.directPaymentToBusiness.bind(this);
    this.directVerificationRequest = this.directVerificationRequest.bind(this);
    this.executeScript = this.executeScript.bind(this);
    this.getScanInformation = this.getScanInformation.bind(this);
    this.requestAnimal = this.requestAnimal.bind(this);
    this.getAnimalInfo = this.getAnimalInfo.bind(this);
    this.getUserInfo = this.getUserInfo.bind(this);
    this.setFormsVacsCertsToState = this.setFormsVacsCertsToState.bind(this);
    this.initDetailedProfileEditingState = this.initDetailedProfileEditingState.bind(this);
    this.uploadFecalExamCertificate = this.uploadFecalExamCertificate.bind(this);
    this.handleMultipleChange = this.handleMultipleChange.bind(this);
    this.removeVaccine = this.removeVaccine.bind(this);
  }
  componentWillMount() {
    var user = firebase.auth().currentUser;

    this.setState({
      isSignedIn: false,
      userProfile: user,
    });
  }

  componentDidMount() {

    const documents = [];
    firebase.firestore().collection('businesses').get()
    .then(snapshot=>{
    snapshot.forEach(doc => {
       documents.push([doc.id,doc.data().name]);
    })
    return documents;
    }).then(documents=>{
      this.setState({
        business:documents
      })
    })

    setTimeout(() => {
      this.checkLogin();
    }, 2000);


  }

  checkLogin(){
    var user = firebase.auth().currentUser;
        if (user) {
          //user has email and password
            this.setState({
            userProfile: user,
          });


          var userRef = firebase.firestore().collection('users').doc(`${user.uid}`);
          userRef.get().then((doc) => {
          // User has a real profile
          if (doc.exists) {     
                  //get activity log
                  const documents2 = [];
                  firebase.firestore().collection('activityLog').where('user', '==', `${user.uid}`).limit(25).get()
                  .then(snapshot=>{
                  snapshot.forEach(doc => {
                    documents2.push([doc.id,doc.data()]);
                  })
                  return documents2;
                  }).then(documents2=>{
                    this.setState({
                      activityLog: documents2,
                    })
                  })

              setTimeout(() => {
                //get profile info
                this.getProfileInfo(0);
                this.setState({
                  isSignedIn: true,
                  pageLoading: false,
                });
              }, 8000);
            }
            else {
              this.getBusinessProfileInfo();
            }
            })       
        } else {
        // No user is signed in.
        }
 }
 


  handleMultipleChange(e) {
    var name;
    var item;
    var itemToDisplay;
    var values = this.state[this.state.animalToEdit].animalVaccinations;
    var valuesToDisplay = this.state[this.state.animalToEdit].animalVaccinationsForDisplay;

    //Adding loop through all options to catch the iphone case
    for (var i = 0; i < e.target.options.length; i++) {
      if (e.target.options[i].selected) {
        name = e.target.options[i].name;
        item = e.target.options[i].value;
        itemToDisplay = e.target.options[i].innerHTML;
        if (values.indexOf(item) < 0) {
          values.push(item);
        };
        if (valuesToDisplay.indexOf(itemToDisplay) < 0) {
          valuesToDisplay.push(itemToDisplay);
        }
      }
    }//loop through all select options
   
    this.setState({
    [this.state.animalToEdit]:{
      ...this.state[this.state.animalToEdit],
        animalVaccinationsForDisplay: valuesToDisplay,
        animalVaccinations: values,
      },
      changeLog: {...this.state.changeLog, 
        [itemToDisplay]: "added"
      }
    });
  }

  removeVaccine = (index) => {
    var values = this.state[this.state.animalToEdit].animalVaccinations;
    var valuesToDisplay = this.state[this.state.animalToEdit].animalVaccinationsForDisplay;
    var valueRemoved = valuesToDisplay[index];
    values.splice(index, 1);

    valuesToDisplay.splice(index, 1);

    this.setState({
      [this.state.animalToEdit]:{
        ...this.state[this.state.animalToEdit],
          animalVaccinationsForDisplay: valuesToDisplay,
          animalVaccinations: values,
        },
        changeLog: {...this.state.changeLog, 
          [valueRemoved]: "removed"
        }
    });
  }

  uploadLicense(animalId) {
    var storageRef = firebase.storage().ref();
    var file = this.state.licenseFile;
    var db = firebase.firestore();
    var uploadDate = Date.now();
    var fileID = `${animalId}_${uploadDate}`;
    var fileType = 'pdf';

    fileID = `${animalId}_${uploadDate}`;

    if (file === null) {
      return;
    } else {
      if(file.type.includes('image')){
        if(file.type.includes('png')){
          fileType = 'png';
        }
        else{
          fileType = 'jpeg';
        }
      }
       else{
        fileType = 'pdf';
      }

      const uploadTask = storageRef.child(`license/${fileID}`).put(file); //create a child directory called images, and place the file inside this directory
      uploadTask.on('state_changed', (snapshot) => {
        // Observe state change events such as progress, pause, and resume
      }, (error) => {
       
        // Handle unsuccessful uploads
      }, () => {
        // Do something once upload is complete
        uploadTask.snapshot.ref.getDownloadURL().then(function (downloadURL) {
          db.collection('animals').doc(animalId).collection('documents').doc(fileID).set({
            comment: "",
            documentType: "certificates",
            filePath: downloadURL,
            fileType: fileType,
            id: fileID,
            lastServiceDate: 0,
            serviceComment: '',
            serviced: false,
            servicedBy: "VERFID",
            status: "initial upload",
            type: "municipality license",
            uploadDate: uploadDate
          }, {
              merge: true
            });
        });
      });
    }
  }



  handleProfileUploadCompression(e) {
    var name = e.target.name;
    var name2 = e.target.name + "Blob";
    var imageFile = e.target.files[0];

    var options = {
      maxSizeMB: 0.2,
      maxWidthOrHeight: 1920,
      useWebWorker: true
    }

    if(imageFile===undefined || imageFile===null || imageFile===[]){
      //do nothing if invalid file
    }else{

    if(imageFile.type.includes('image')){
      imageCompression(imageFile, options)
      .then((compressedFile) => {
        this.setState({ [name]: compressedFile });
        this.setState({ [name2]: URL.createObjectURL(compressedFile) }, null);
        return compressedFile;
      })
      .then(function (compressedFile) {

      })
      .catch(function (error) {
        alert('Your image was unable to be compressed');
      });
    }
    else{
      this.setState({ [name]: imageFile,
        [name2]: URL.createObjectURL(imageFile)
      });
    }
  }
  }

  uploadDogImage(animalID) {
    var storageRef = firebase.storage().ref();
    var db = firebase.firestore();
    var dogPicture = this.state.dogImage;
    if (dogPicture === null) {
      return;
    }
    const uploadTask = storageRef.child(`dogImage/${animalID}`).put(dogPicture); //create a child directory called images, and place the file inside this directory
    uploadTask.on('state_changed', (snapshot) => {
      // Observe state change events such as progress, pause, and resume
    }, (error) => {
      // Handle unsuccessful uploads
    }, (snapshot) => {
      // Do something once upload is complete
      uploadTask.snapshot.ref.getDownloadURL().then(function (downloadURL) {
        db.collection('animals').doc(`${animalID}`).update({
          imageUrl: downloadURL,
        })
      });

    });
  }

  canineBreedToggle() {
    if (this.state.isCanineBreedToggled) {
      this.setState({
        isCanineBreedToggled: false,
      })
    } else {
      this.setState({
        isCanineBreedToggled: true,
      })
    }
  }

  requestAnimal(name, animalID){
    var animalRef = firebase.firestore().collection('animals').doc(`${animalID}`);

    animalRef.get()
    .then(doc => {
      if (!doc.exists) {
        //doc exists and not ready for transfer
        alert("This animal does not exist. \nPlease contact the owner or support@verfidpet.com with questions.")
      } else {
        if(doc.data().transfer && (doc.data().name===name)){
        alert("Success - "+name+" is being transferred into your account! \nThis can take up to 3-5 minutes. You must refresh your page for it to show up in your account.")
          //doc exists and ready for transfer
          animalRef.update({transfer:false,userId:this.state.userProfile.uid})

        }
        else{
          alert("This animal is not ready to be transferred. Make sure the name is correct (case sensitive) and the owner has released the pet. \nPlease contact the owner or support@verfidpet.com with questions.")
          //doc exists and not ready for transfer
        }
      }
    })
    .catch(err => {
        alert("Something went wrong. Please check internet connection and try again later.")
    });
    
  }

  canineVaccineToggle() {
    if (this.state.isCanineVaccineToggled) {
      this.setState({
        isCanineVaccineToggled: false,
      })
    } else {
      this.setState({
        isCanineVaccineToggled: true,
      })
    }
  }

  felineBreedToggle() {
    if (this.state.isFelineBreedToggled) {
      this.setState({
        isFelineBreedToggled: false,
      })
    } else {
      this.setState({
        isFelineBreedToggled: true,
      })
    }
  }

  felineVaccineToggle() {
    if (this.state.isFelineVaccineToggled) {
      this.setState({
        isFelineVaccineToggled: false,
      })
    } else {
      this.setState({
        isFelineVaccineToggled: true,
      })
    }
  }

  editingUser() {
    if (this.state.isProfileEditingUser) {
      this.setState({
        isProfileEditingUser: false,
      })
    } else {
      this.setState({
        isProfileEditingUser: true,
      })
    }
  }

  editingAnimal() {
    if (this.state.isProfileEditingAnimal) {
      this.setState({
        isProfileEditingAnimal: false,
      })
    } else {
      this.setState({
        isProfileEditingAnimal: true,
      })
    }
  }

  toggleProfileEditingUser(index) {
    this.setState({gotProfileInfo: false}); //force update
    setTimeout(() => this.editingUser(), 1000);
    this.getProfileInfo(index);
    //need the delay in set state to ensure there is no race condition
  }

  transferPet(name, animalId, action){
    var animalRef = firebase.firestore().collection('animals').doc(`${animalId}`);
    animalRef.update({
      transfer: action,
      })
      this.setState({[animalId]:{...this.state[animalId], transfer:action}})
    if(action){
    alert('Your request to transfer this pet ' + name + ' has been received. \nProvide transfer code: ' + animalId + ' to the pet recipient.')
    }
    else{
      alert('Your request to transfer this pet ' + name + ' has been cancelled.')
    }
  }

  toggleProfileEditingAnimal(index) {
    this.setState({gotAnimalInfo: false,
                  animalToEdit:index}); //force update
    setTimeout(() => this.editingAnimal(), 1000);
    this.getProfileInfo(index);
    //need the delay in set state to ensure there is no race condition
  }

  toggleBusinessProfileEditing() {
    if (this.state.isBusinessProfileEditing) {
      this.setState({
        isBusinessProfileEditing: false,
      })
    } else {
      this.setState({
        isBusinessProfileEditing: true,
      })
    }
  }

  updateProfileAnimal() {
    var animalRef = firebase.firestore().collection('animals').doc(`${this.state.animalToEdit}`);
    var weightParsed = parseInt(this.state[this.state.animalToEdit].weight, 10);

    var FecalExamExpirationDateString = new Date(this.state[this.state.animalToEdit].FecalExamExpirationDate);
    var FecalExamExpirationDateToPost = FecalExamExpirationDateString.getTime() + 86400000;//adds one day to the string;
    var fecalExamSelected = (this.state[this.state.animalToEdit].fecalExam === true || this.state[this.state.animalToEdit].fecalExam === "true") ? true : false;
    var fecalCert =  `${this.state[this.state.animalToEdit].species}Cert3`;
    var FecalExamHumanReadableDate = (new Date(FecalExamExpirationDateToPost).toLocaleString());
    var FecalExamCertificateExists = (this.state.fecalExamCertificate !== null && this.state.fecalExamCertificate !== [] && this.state.fecalExamCertificate !== undefined) ? true : false;

  
    var vetCert = `${this.state[this.state.animalToEdit].species}Cert0`;
    var VetHealthIssueString =  new Date(this.state[this.state.animalToEdit].VetHealthIssueDate);
    var VetHealthExpirationString =  new Date(this.state[this.state.animalToEdit].VetHealthExpirationDate);
    var VetHealthIssueDateToPost =  VetHealthIssueString.getTime() + 86400000;
    var VetHealthExpirationDateToPost =  VetHealthExpirationString.getTime() + 86400000;
    var VetHealthIssueHumanReadable =  (new Date(VetHealthIssueDateToPost).toLocaleString());
    var VetHealthExpirationHumanReadable =  (new Date(VetHealthExpirationDateToPost).toLocaleString());

    var vetHealthCertSelected = (this.state[this.state.animalToEdit].vetHealthCert === true || this.state[this.state.animalToEdit].vetHealthCert === "true") ? true : false;
    var vetHealthCertFileExists = (this.state.veterinaryHealthCertificate !== null && this.state.veterinaryHealthCertificate !== [] && this.state.veterinaryHealthCertificate !== undefined) ? true : false;
    
    var supportCert = `${this.state[this.state.animalToEdit].species}Cert1`;
    var supportCertSelected = (this.state[this.state.animalToEdit].emotionalSupportAnimal === true || this.state[this.state.animalToEdit].emotionalSupportAnimal === "true") ? true : false;
    
    var var1 = this.state[this.state.animalToEdit].animalBirthDate;
    var var2 = this.state[this.state.animalToEdit].birthDateFormatted;
    var var3 = var1 || var2;
    var birthDateString = new Date(var3);
    var birthDateToPost =  birthDateString.getTime() + 86400000;

    var1 = this.state[this.state.animalToEdit].ownershipDate;
    var2 = this.state[this.state.animalToEdit].ownedSince;
    var3 = var1 || var2;
    var ownedSinceString =  new Date(var3);
    var ownedSinceToPost =  ownedSinceString.getTime() + 86400000;

      this.setState({isLoadingAnimalInfo: true})
      animalRef.update({
          name: this.state[this.state.animalToEdit].animalName || this.state[this.state.animalToEdit].name,
          fixed: this.state[this.state.animalToEdit].fixed === 'true' || this.state[this.state.animalToEdit].fixed ? true : false,
          weight: weightParsed,
          comment: this.state[this.state.animalToEdit].animalComments || this.state[this.state.animalToEdit].comment,
          breed: this.state[this.state.animalToEdit].breed || this.state[this.state.animalToEdit].breed,
          breed2: this.state[this.state.animalToEdit].breed2 || this.state[this.state.animalToEdit].breed2,
          gender: this.state[this.state.animalToEdit].gender,
          birthDate: birthDateToPost,
          ownedSince: ownedSinceToPost,

      })
      .then(()=>{
        var dateNow = Date.now();
        firebase.firestore().collection('activityLog').doc(`${dateNow}`).set({...this.state.changeLog, time:dateNow, user:this.state.profileInfo.userId, animalId:this.state.animalToEdit, animalName:`${this.state[this.state.animalToEdit].animalName || this.state[this.state.animalToEdit].name}`, type:"profileUpdate"});
      })
      .then(() => {
        this.state.fileVacs === null ? null : this.uploadVaccinations(this.state[this.state.animalToEdit].animalId);
      })
      .then(() => {
        (this.state.fileSN === null || this.state.fileSN === undefined) ? null : this.uploadSpayNeuter(this.state[this.state.animalToEdit].animalId);
      })
      .then(() => {
        this.state.esaFile === null ? null : this.uploadESANote(this.state[this.state.animalToEdit].animalId)
      })
      .then(() => {
        ((this.state.licenseFile === null) || (this.state.licenseFile === [] || this.state.licenseFile === undefined))? null : this.uploadLicense(this.state[this.state.animalToEdit].animalId)
      })
      .then(() => {
        vetHealthCertFileExists === null ? null : this.uploadVetHealthCertificate(this.state[this.state.animalToEdit].animalId)
      })
      .then(() => {
        vetHealthCertSelected? animalRef.collection('certificates').doc(`${vetCert}`).set({
          verified: false,
          issue: Number.isNaN(VetHealthIssueDateToPost)? 0:VetHealthIssueDateToPost,
          issueHumanReadable: VetHealthIssueHumanReadable,
          expiration:Number.isNaN(VetHealthExpirationDateToPost)?0:VetHealthExpirationDateToPost,
          expirationHumanReadable:VetHealthExpirationHumanReadable,
        }) : null
        })
        .then(() => {
          fecalExamSelected? animalRef.collection('certificates').doc(`${fecalCert}`).set({
            verified: false,
            expiration:Number.isNaN(FecalExamExpirationDateToPost)?0:FecalExamExpirationDateToPost,
            expirationHumanReadable:FecalExamHumanReadableDate,
          }) : null
      })
      .then(() => {
        supportCertSelected? animalRef.collection('certificates').doc(`${supportCert}`).set({
          verified: false,
        }) : null
      })
      .then(()=>{
        FecalExamCertificateExists? this.uploadFecalExamCertificate(this.state.animalToEdit) : null
      })
      .then(() => {
        this.state.dogImage === null ? null : this.uploadDogImage(this.state.animalToEdit)
      })
      .then(() => {
        this.setState({
          file: null,
          fileSN: null,
          profilePicture: null,
          profilePictureBlob: null,
          esaFile: null,
          dogImage: null,
          dogImageBlob: null,
          veterinaryHealthCertificate: null,
        })
      })
      .then(() => {
        this.setState({
          isProfileEditingAnimal: false,
        });
      })
      .then(() => {
        setTimeout(() => {
          this.getProfileInfo(0);       
          this.setState({isLoadingAnimalInfo: false})
      }, 6000)
      })
  }

  updateProfileUser() {
    var userRef = firebase.firestore().collection('users').doc(`${this.state.userProfile.uid}`);
    userRef.update({
      firstName: this.state.profileInfo.firstName,
      lastName: this.state.profileInfo.lastName,
      email: this.state.profileInfo.email,
      address: {
        city: this.state.profileInfo.city || this.state.profileInfo.address.city,
        state: this.state.profileInfo.state || this.state.profileInfo.address.state,
        line1: this.state.profileInfo.line1 || this.state.profileInfo.address.line1,
        line2: this.state.profileInfo.line2 || this.state.profileInfo.address.line2 || "",
        country: this.state.profileInfo.country || this.state.profileInfo.address.country,
        zip: this.state.profileInfo.zip || this.state.profileInfo.address.zip,
      },
      phoneNumberPrimary: this.state.profileInfo.phoneNumberPrimary,
      birthDate: this.state.profileInfo.birthDate,
    })
    .then(() => {
        this.state.profilePicture === null ? null : this.uploadProfileImage();
      })
      .then(() => {
        this.setState({
          isProfileEditingUser: false,
        });
      })
      .then(() => {
        setTimeout(() => this.getProfileInfo(0), 10000)
      })
  }





  uploadESANote(animalId) {

    var storageRef = firebase.storage().ref();
    var file = this.state.esaFile;
    var db = firebase.firestore();
    var uploadDate = Date.now();
    var fileID = `${animalId}_${uploadDate}`;
    var fileType = 'pdf';

    fileID = `${animalId}_${uploadDate}`;

    if (file === null) {
      return;
    } else {
      if(file.type.includes('image')){
        if(file.type.includes('png')){
          fileType = 'png';
        }
        else{
          fileType = 'jpeg';
        }
      }
       else{
        fileType = 'pdf';
      }

      const uploadTask = storageRef.child(`emotionalSupportNotes/${fileID}`).put(file); //create a child directory called images, and place the file inside this directory
      uploadTask.on('state_changed', (snapshot) => {
        // Observe state change events such as progress, pause, and resume
      }, (error) => {
      
        // Handle unsuccessful uploads
      }, () => {
        // Do something once upload is complete
        uploadTask.snapshot.ref.getDownloadURL().then(function (downloadURL) {
          db.collection('animals').doc(animalId).collection('documents').doc(fileID).set({
            comment: "",
            documentType: "certificates",
            filePath: downloadURL,
            fileType: fileType,
            id: fileID,
            lastServiceDate: 0,
            serviceComment: '',
            serviced: false,
            servicedBy: "VERFID",
            status: "initial upload",
            type: "support animal",
            uploadDate: uploadDate
          }, {
              merge: true
            });
        });
      });
    }
    /*var storageRef = firebase.storage().ref();
    var esaNote = this.state.esaFile;
    var userId = this.state.userProfile.uid;
    var db = firebase.firestore();
    var fileID = Math.floor((1 + Math.random()) * 0x10000).toString(4).substring(1);
    if (esaNote === null) {
      return;
    } else {
      const uploadTask = storageRef.child(`emotionalSupportNotes/${this.state.profileInfo.userId}_${fileID}`).put(esaNote); //create a child directory called images, and place the file inside this directory
      uploadTask.on('state_changed', (snapshot) => {
        // Observe state change events such as progress, pause, and resume
      }, (error) => {
        // Handle unsuccessful uploads
      }, () => {
        // Do something once upload is complete
        uploadTask.snapshot.ref.getDownloadURL().then(function (downloadURL) {
          db.collection('users').doc(userId).set({
            emotionalSupportNote: downloadURL,
            emotionalSupportVerified: false,
          }, {
              merge: true
            });
        });
      });
    }*/
  }

  uploadVetHealthCertificate(animalId) {
    var storageRef = firebase.storage().ref();
    var vetNote = this.state.veterinaryHealthCertificate;
    var db = firebase.firestore();
    var uploadDate = Date.now();
    var fileID = `${animalId}_${uploadDate}`;
    
    var fileType = 'pdf';
    if ((vetNote === null) || (vetNote===undefined)) {
      return;
    } else {
      if(vetNote.type.includes('image')){
        if(vetNote.type.includes('png')){
          fileType = 'png';
        }
        else{
          fileType = 'jpeg';
        }
      }
       else{
        fileType = 'pdf';
      }

      const uploadTask = storageRef.child(`veterinaryHealthCertificate/${fileID}`).put(vetNote); //create a child directory called images, and place the file inside this directory
      uploadTask.on('state_changed', (snapshot) => {
        // Observe state change events such as progress, pause, and resume
      }, (error) => {
        // Handle unsuccessful uploads
      }, () => {
        // Do something once upload is complete
        uploadTask.snapshot.ref.getDownloadURL().then(function (downloadURL) {
          db.collection('animals').doc(animalId).collection('documents').doc(fileID).set({
            comment: "",
            documentType: "certificate",
            filePath: downloadURL,
            fileType: fileType,
            id: fileID,
            lastServiceDate: 0,
            serviceComment: '',
            serviced: false,
            servicedBy: "VERFID",
            status: "initial upload",
            type: "vet health certificate",
            uploadDate: uploadDate
          }, {
              merge: true
            });
        });
      });
    }
  }

  orderNewtag(animalId) {
    if(animalId !== this.state.animalToAddTagsFor){
    this.setState({
      animalToAddTagsFor: animalId,
      numberOfTags: 1,
    })
    }else{
      this.setState({
        animalToAddTagsFor: 0,
        numberOfTags: 1,
      })
    }
  }

  setNumTags(e) {
    this.setState({ numberOfTags: e.target.value })
  }

  uploadBusinessProfiePic = () => {
    var storageRef = firebase.storage().ref();
    var profilePicture = this.state.profileUpload;
    var businessID = this.state.businessInfo.businessId;
    var db = firebase.firestore();
    const uploadTask = storageRef.child(`profileImage/${this.state.name}`).put(profilePicture); //create a child directory called images, and place the file inside this directory
    uploadTask.on('state_changed', (snapshot) => {
      // Observe state change events such as progress, pause, and resume
    }, (error) => {
      // Handle unsuccessful uploads
    }, () => {
      // Do something once upload is complete
      uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) => {
        db.collection('businesses').doc(`${businessID}`).update({
          imageUrl: downloadURL,
        })
      });
    });
  }
  uploadProfileImage() {
    var storageRef = firebase.storage().ref();
    var profilePicture = this.state.profilePicture;
    var db = firebase.firestore();
    var userId = this.state.userProfile.uid;
    if ((profilePicture === null) || (profilePicture === undefined)) {
      return;
    } else {
      const uploadTask = storageRef.child(`profileImage/${userId}`).put(profilePicture); //create a child directory called images, and place the file inside this directory
      uploadTask.on('state_changed', (snapshot) => {
        // Observe state change events such as progress, pause, and resume
      }, (error) => {
        // Handle unsuccessful uploads
      }, () => {
        // Do something once upload is complete
        uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) => {
          db.collection('users').doc(`${userId}`).update({
            imageUrl: downloadURL,
          })
        });
      });
    }
  }

  uploadVaccinations(animalId) {

    var storageRef = firebase.storage().ref();
    var file = this.state.fileVacs;
    var db = firebase.firestore();
    var uploadDate = Date.now();
    var fileID = `${animalId}_${uploadDate}`;
    var fileType = 'pdf';    

    if ((file === null) || (file===undefined))  {
      return;
    } else {
      if(file.type.includes('image')){
        if(file.type.includes('png')){
          fileType = 'png';
        }
        else{
          fileType = 'jpeg';
        }
      }
       else{
        fileType = 'pdf';
      }

      const uploadTask = storageRef.child(`vaccinations/${fileID}`).put(file); //create a child directory called images, and place the file inside this directory
      uploadTask.on('state_changed', (snapshot) => {
        // Observe state change events such as progress, pause, and resume
      }, (error) => {
        // Handle unsuccessful uploads
      }, () => {
        // Do something once upload is complete
        uploadTask.snapshot.ref.getDownloadURL().then(function (downloadURL) {
          db.collection('animals').doc(animalId).collection('documents').doc(fileID).set({
            comment: "",
            documentType: "vaccinations",
            filePath: downloadURL,
            fileType: fileType,
            id: fileID,
            lastServiceDate: 0,
            serviceComment: '',
            serviced: false,
            servicedBy: "VERFID",
            status: "initial upload",
            type: "vaccinations",
            uploadDate: uploadDate
          }, {
              merge: true
            });
        });
      });
    }
  

   /* var storageRef = firebase.storage().ref();
    var uploadFile = this.state.file;
    var fileID = Math.floor((1 + Math.random()) * 0x10000).toString(4).substring(1);
    if (uploadFile === null) {
      return;
    } else {
      const uploadTask = storageRef.child(`vaccinations/${animalId}_${fileID}`).put(uploadFile);
      uploadTask.on('state_changed', (snapshot) => {
        // Observe state change events such as progress, pause, and resume
      }, (error) => {
        // Handle unsuccessful uploads
      }, () => {
        // Do something once upload is complete
        uploadTask.snapshot.ref.getDownloadURL().then(function (downloadURL) {
        });
      });
    }
    */
  }

  uploadSpayNeuter(animalId) {
    var storageRef = firebase.storage().ref();
    var uploadFile = this.state.fileSN;
    var db = firebase.firestore();
    var uploadDate = Date.now();
    var fileID = `${animalId}_${uploadDate}`;
    
    var fileType = 'pdf';
    if ((uploadFile === null) || (uploadFile===undefined)) {
      return;
    } else {
      if(uploadFile.type.includes('image')){
        if(uploadFile.type.includes('png')){
          fileType = 'png';
        }
        else{
          fileType = 'jpeg';
        }
      }
       else{
        fileType = 'pdf';
      }

      const uploadTask = storageRef.child(`SpayNeuter/${fileID}`).put(uploadFile); //create a child directory called images, and place the file inside this directory
      uploadTask.on('state_changed', (snapshot) => {
        // Observe state change events such as progress, pause, and resume
      }, (error) => {
        // Handle unsuccessful uploads
      }, () => {
        // Do something once upload is complete
        uploadTask.snapshot.ref.getDownloadURL().then(function (downloadURL) {
          db.collection('animals').doc(animalId).collection('documents').doc(fileID).set({
            comment: "",
            documentType: "certificate",
            filePath: downloadURL,
            fileType: fileType,
            id: fileID,
            lastServiceDate: 0,
            serviceComment: '',
            serviced: false,
            servicedBy: "VERFID",
            status: "initial upload",
            type: "spay and neuter",
            uploadDate: uploadDate
          }, {
              merge: true
            });
        });
      });
    }

  /*  var storageRef = firebase.storage().ref();
    var uploadFile = this.state.fileSN;
    var fileID = Math.floor((1 + Math.random()) * 0x10000).toString(4).substring(1);
    if (uploadFile === null) {
      return;
    } else {
      const uploadTask = storageRef.child(`SpayNeuter/${animalId}_${fileID}`).put(uploadFile);
      uploadTask.on('state_changed', (snapshot) => {
        // Observe state change events such as progress, pause, and resume
      }, (error) => {
        // Handle unsuccessful uploads
      }, () => {
        // Do something once upload is complete
        uploadTask.snapshot.ref.getDownloadURL().then(function (downloadURL) {
        });
      });
    }*/
  } 

  updateBusinessProfile() {
    var businessRef = firebase.firestore().collection('businesses').doc(`${this.state.userProfile.uid}`);

    businessRef.update({
      name: this.state.businessInfo.name,
      email: this.state.businessInfo.email,
      address: {
        city: this.state.businessInfo.city || this.state.businessInfo.address.city,
        state: this.state.businessInfo.state || this.state.businessInfo.address.state,
        line1: this.state.businessInfo.line1 || this.state.businessInfo.address.line1,
        line2: this.state.businessInfo.line2 || this.state.businessInfo.address.line2 || '',
        country: this.state.businessInfo.country || this.state.businessInfo.address.country || 'United States',
        zip: this.state.businessInfo.zip || this.state.businessInfo.address.zip,
      },
      phoneNumberPrimary: this.state.businessInfo.phoneNumberPrimary,
      website: this.state.businessInfo.website,
    })
      .then(() => {
        this.state.profileUpload === null ? null : this.uploadBusinessProfiePic();
      })
      .then(() => {
        this.setState({
          isBusinessProfileEditing: false,
        });
      })
      .then(() => {
        setTimeout(() => this.getBusinessProfileInfo(), 5000)
      });

  }
  getBusinessProfileInfo() {
    if (firebase.auth().currentUser) {
      //first getting business basic info
      var businessRef = firebase.firestore().collection('businesses').doc(`${this.state.userProfile.uid}`);
      // var animalRef;
      // var animalInfo;
      var businessProfileInfo;
      businessRef.get().then((doc) => {
        if (doc.exists) {
          //doc exists!
          businessProfileInfo = doc.data();
          this.setState({
            invalidProfile:false,
            isSignedIn: true})     
          return businessProfileInfo;
        } else {
          this.setState({
            invalidProfile:true,
            pageLoading: false})
        }
      })
        .then((businessProfileInfo) => {
          this.setState({
            businessInfo: businessProfileInfo,
            businessImage: businessProfileInfo.imageUrl
          });
              //store vaccinations definitions
              firebase.firestore().collection('vaccinations').doc('canine').get()
              .then((doc) => {
                if (doc.exists) {
                  this.setState({canineVacs:doc.data()})
                }
              })
    
              firebase.firestore().collection('vaccinations').doc('feline').get()
              .then((doc) => {
                if (doc.exists) {
                  this.setState({felineVacs:doc.data()})
                }
              })
              
              //store cert definitions
              firebase.firestore().collection('certificates').doc('canine').get()
              .then((doc) => {
                if (doc.exists) {
                  this.setState({canineCerts:doc.data()})
                }
              })
    
              firebase.firestore().collection('certificates').doc('feline').get()
              .then((doc) => {
                if (doc.exists) {
                  this.setState({felineCerts:doc.data()})
                }
              })
    
              //store form definitions
              firebase.firestore().collection('forms').doc('canine').get()
              .then((doc) => {
                if (doc.exists) {
                  this.setState({canineForms:doc.data()})
                }
              })
    
              firebase.firestore().collection('forms').doc('feline').get()
              .then((doc) => {
                if (doc.exists) {
                  this.setState({felineForms:doc.data()})
                }
              })
        })
        .then(() =>{
          //get canine requirements
          firebase.firestore().collection('businesses').doc(`${this.state.userProfile.uid}`).collection('requirements').doc('canine').get()
          .then((doc) => {
              this.setState({canineRequirements: doc.data()}) 
              })
              .then(() =>{
                //get feline requirements
                firebase.firestore().collection('businesses').doc(`${this.state.userProfile.uid}`).collection('requirements').doc('feline').get()
                    .then((doc) => {
                      if(doc.exists){
                      this.setState({felineRequirements: doc.data()},()=>{this.setState({pageLoading: false});}) 
                      }
                      else{
                        this.setState({pageLoading: false})
                      }
                     })
              })
        })
        .catch((err) => {
        });

        //now get payment logs in parallel
        const documents=[];
        var temp, newDoc;
        firebase.firestore().collection('activityLog').where('business', '==', `${this.state.userProfile.uid}`).limit(25).get()
        .then(snapshot=>{
        snapshot.forEach(doc => {
          newDoc = doc.data();
          temp = (new Date(doc.data().time).toLocaleDateString());
          newDoc = {...doc.data(), readableTime:temp}
          
          documents.push(newDoc);
        })
        return documents;
        })
        .then(documents=>{
          this.setState({
            businessPaymentLog: documents,
          })
        })
    }
  }

  getProfileInfo(index) {

    if (firebase.auth().currentUser) {
      var userRef = firebase.firestore().collection('users').doc(`${this.state.userProfile.uid}`);
      var userInfo;

      if(this.state.gotProfileInfo===false){
      userRef.get().then((doc) => {
        if (doc.exists) {
          userInfo = doc.data();
          return userInfo;
        } else {
        }
      })
        .then((userInfo) => {
          this.setState({
            profileInfo: userInfo,
            profileImage: userInfo.imageUrl,
            gotProfileInfo: true,
          });
        })
      } //if already got user info
        
      if(this.state.gotAnimalInfo===false){
         
          //store vaccinations definitions
          firebase.firestore().collection('vaccinations').doc('canine').get()
          .then((doc) => {
            if (doc.exists) {
              this.setState({canineVacs:doc.data()})
            }
          })

          firebase.firestore().collection('vaccinations').doc('feline').get()
          .then((doc) => {
            if (doc.exists) {
              this.setState({felineVacs:doc.data()})
            }
          })

          setTimeout(()=>{
          firebase.firestore().collection('animals').where('userId', '==', `${this.state.userProfile.uid}`).get()
          .then(snapshot => {
            if (snapshot.empty) {
              return;
            }      
            var count = 0;
            var lowCount = 0;
            var array = [];
            snapshot.forEach(doc => {
              array.push(doc.data().animalId);
              this.setState({[`${doc.data().animalId}`]:doc.data(), animalExists:true},()=>{
                var birthDateFormatted =new Date((this.state[doc.data().animalId].birthDate-86400000)).toISOString().split('T')[0];
                var ownedSinceFormatted =new Date((this.state[doc.data().animalId].ownedSince-86400000)).toISOString().split('T')[0];
                var breed2 = this.state[doc.data().animalId].breed2 === ""? "Not Applicable":this.state[doc.data().animalId].breed2;
                this.setState({
                  [doc.data().animalId]:{
                    ...this.state[doc.data().animalId],
                    birthDateFormatted: birthDateFormatted,
                    ownedSinceFormatted: ownedSinceFormatted,
                    breed2:breed2,
                    }
                })
              })
              this.setFormsVacsCertsToState(doc.data().animalId)
              var id = doc.data().animalId; //need variable with reduced scope to prevent overwriting values
              var docDisplayArray = []; //need to limit scope so adjacent rendering doesn't break it
              firebase.firestore().collection('animals').doc(id).collection('documents').get()
              .then((snapshot)=>{
                this.setState({[`${id}DocNum`]:snapshot.docs.length})
                if (snapshot.empty) {
                  return;
                }  
                lowCount=0;
                snapshot.forEach(doc => {
                  docDisplayArray.push(doc.data());
                  //this.setState({[`${id}DocNum${lowCount}`]:doc.data()});
                  lowCount = lowCount+1;
                })
                setTimeout(()=>{this.setState({[`${id}DocsToView`]:docDisplayArray})},1000)

              })
              count= count + 1;
            });
            this.setState({Animals: array})

            })
            },1000);

          //store cert definitions
          firebase.firestore().collection('certificates').doc('canine').get()
          .then((doc) => {
            if (doc.exists) {
              this.setState({canineCerts:doc.data()})
            }
          })

          firebase.firestore().collection('certificates').doc('feline').get()
          .then((doc) => {
            if (doc.exists) {
              this.setState({felineCerts:doc.data()})
            }
          })

          //store form definitions
          firebase.firestore().collection('forms').doc('canine').get()
          .then((doc) => {
            if (doc.exists) {
              this.setState({canineForms:doc.data()})
            }
          })

          firebase.firestore().collection('forms').doc('feline').get()
          .then((doc) => {
            if (doc.exists) {
              this.setState({felineForms:doc.data()})
            }
          })
          .then(() => {
            setTimeout(() => {
             
              this.setState({
                isLoadingAnimalInfo: false,
                gotAnimalInfo: true});
            }, 6000);            
          })      
        .catch((err) => {
          console.log(err)
        });
      }//if already got animal info
    }
    
  }

  initDetailedProfileEditingState(animalId){


    //fecal exam
    if(this.state[`${animalId}${"canineCert3"}`]!==undefined)
    {
      this.setState({
        [animalId]:{
          ...this.state[animalId],
          fecalExam: true,
          FecalExamExpirationDate: this.state[`${animalId}${"canineCert3"}`].expiration && new Date(this.state[`${animalId}${"canineCert3"}`].expiration).toISOString().split('T')[0],
          }
      })
   }
   else if((this.state[`${animalId}${"felineCert3"}`]!==undefined)){
    this.setState({
      [animalId]:{
        ...this.state[animalId],
        fecalExam: true,
        FecalExamExpirationDate: this.state[`${animalId}${"felineCert3"}`].expiration && new Date(this.state[`${animalId}${"felineCert3"}`].expiration).toISOString().split('T')[0],
      }
    })  
   }
   else{
      this.setState({
        [animalId]:{
          ...this.state[animalId],
          fecalExam: false,
          }
      })  
  }

  //veterinary health certificate
  if(this.state[`${animalId}${"canineCert0"}`]!==undefined)
  {
    this.setState({
      [animalId]:{
        ...this.state[animalId],
        vetHealthCert: true,
        VetHealthIssueDate: (this.state[`${animalId}${"canineCert0"}`].issue ===undefined) ? null: new Date(this.state[`${animalId}${"canineCert0"}`].issue).toISOString().split('T')[0],
        VetHealthExpirationDate: this.state[`${animalId}${"canineCert0"}`].expiration && new Date(this.state[`${animalId}${"canineCert0"}`].expiration).toISOString().split('T')[0],
        }
    })
 }
 else if((this.state[`${animalId}${"felineCert0"}`]!==undefined)){
  this.setState({
    [animalId]:{
      ...this.state[animalId],
      vetHealthCert: true,
      VetHealthIssueDate: (this.state[`${animalId}${"felineCert0"}`].issue ===undefined) ? null: Date(this.state[`${animalId}${"felineCert0"}`].issue).toISOString().split('T')[0],
      VetHealthExpirationDate: this.state[`${animalId}${"felineCert0"}`].expiration && new Date(this.state[`${animalId}${"felineCert0"}`].expiration).toISOString().split('T')[0],
    }
  })  
 }
 else{
    this.setState({
      [animalId]:{
        ...this.state[animalId],
        vetHealthCert: false,
        }
    })  
}

 //support animal
 if(this.state[`${animalId}${"canineCert1"}`]!==undefined)
 {
   this.setState({
     [animalId]:{
       ...this.state[animalId],
       emotionalSupportAnimal: true,
       }
   })
}
else if((this.state[`${animalId}${"felineCert1"}`]!==undefined)){
 this.setState({
   [animalId]:{
     ...this.state[animalId],
     emotionalSupportAnimal: true,
   }
 })  
}
else{
   this.setState({
     [animalId]:{
       ...this.state[animalId],
       emotionalSupportAnimal: false,
       }
   })  
}

//licensed animal
if(this.state[`${animalId}${"canineCert500"}`]!==undefined)
{
  this.setState({
    [animalId]:{
      ...this.state[animalId],
      licensed: true,
      }
  })
}
else if((this.state[`${animalId}${"felineCert500"}`]!==undefined)){
this.setState({
  [animalId]:{
    ...this.state[animalId],
    licensed: true,
  }
})  
}
else{
  this.setState({
    [animalId]:{
      ...this.state[animalId],
      licensed: false,
      }
  })  
}

  }

  setFormsVacsCertsToState(animalId){

      var index = 0;
      var valuesToDisplay=[];
      var values=[];
      var pathVac = firebase.firestore().collection('animals').doc(`${animalId}`).collection('vaccinations');
      var pathForm = firebase.firestore().collection('animals').doc(`${animalId}`).collection('forms');
      var pathCert = firebase.firestore().collection('animals').doc(`${animalId}`).collection('certificates');
      pathVac.get()
      .then(snapshot => {
        if (snapshot.empty) {
          return;
        }  
        snapshot.forEach(doc => {
            values.push(doc.id);
            if(this.state[animalId].species==="canine"){
            valuesToDisplay.push(this.state.canineVacs[doc.id].name);
            }
            else{
            valuesToDisplay.push(this.state.felineVacs[doc.id].name);
            }
            index = index + 1;
          this.setState({[`${animalId}${doc.id}`]:doc.data(),
              [animalId]:{
            ...this.state[animalId],
            [`${doc.id}Date`]:(new Date(doc.data().expiration).toISOString().split('T')[0]), 
            }
          })      
          })                 
          return index;
        })
        .then(()=>{
          this.setState({
            [animalId]:{
              ...this.state[animalId],
                animalType : this.state[animalId].species,
                animalVaccinationsForDisplay: valuesToDisplay,
                animalVaccinations: values,
              }
          }) 
        })
        .then(()=>{
          this.initDetailedProfileEditingState(animalId);
        })
        .catch(err => {
          console.log('Error getting vaccs', err);
        });

      pathForm.get()
      .then(snapshot => {
        if (snapshot.empty) {
          return;
        }  
        snapshot.forEach(doc => {
          this.setState({[`${animalId}${doc.id}`]:doc.data()})
        });
      })
      .catch(err => {
        console.log('Error getting forms', err);
      });

      pathCert.get()
      .then(snapshot => {
        if (snapshot.empty) {
          return;
        }  
        snapshot.forEach(doc => {
          this.setState({[`${animalId}${doc.id}`]:doc.data()})
        });
      })
      .catch(err => {
        console.log('Error getting docs', err);
      });
}

  getAnimalInfo(animalId) {
    var animalInfo = [];

    if (firebase.auth().currentUser) {
      firebase.firestore().collection('animals').doc(animalId).get()
        .then((doc) => {
          if (doc.exists) {
            animalInfo = doc.data().name;
            return { name: doc.data().name, userId: doc.data().userId };
          }
          else {
            return null;
          }
        })
        .then((animalInfo) => {
          this.setState({
            [animalId]: animalInfo,
          })
        })
        .catch((err) => {
          return null;
        })
    }
  }

  getUserInfo(userId) {
    var userInfo = [];
    if (firebase.auth().currentUser) {
      firebase.firestore().collection('users').doc(`${userId}`).get()
        .then((doc) => {
          if (doc.exists) {
            userInfo = doc.data().firstName + " " + doc.data().lastName;
            return { name: userInfo, phone: doc.data().phoneNumberPrimary };
          }
          else {
            return null;
          }
        }
        )
        .then((userInfo) => {
          this.setState({
            [userId]: userInfo,
          })
        })
        .catch((err) => {
          return null;
        })
    }
  }


  getScanInformation() {

    var buffer = [];
    var animalIdArray = [];
    var finalResult = [];
    var finalResult2 = [];
    var dataDoc;
    var startDate = (new Date(this.state.startDate)).getTime()-86400000;
    var endDate = (new Date(this.state.endDate)).getTime()+86400000; //adds padding to make sure to account for time zones

    var id = this.state.userProfile.uid;
    var db = firebase.firestore();
    var location = db.collection('scans').doc('authenticated').collection(id).where('scanDate','>',startDate).where('scanDate','<',endDate).limit(100);
    this.setState({
      scanInfoLoading: true,
    });

    let query = location.get()
      .then(snapshot => {
      
        snapshot.forEach(doc => {
          //make temporary data buffer that we can maniuplate the data with
          dataDoc = doc.data();
          //now update the date with something that does not look like garbage
          dataDoc.scanDate = new Date(dataDoc.scanDate).toLocaleString();
          dataDoc.eventType = (dataDoc.eventType==="checkIn")? "Check In": "Check Out";
          buffer.push(dataDoc);
          animalIdArray.push(dataDoc.animalId);

        });

        return [animalIdArray, buffer];
      })
      .then(buffer => {
        //now grab all the relevant animal info
        buffer[0].map(element => {
          this.getAnimalInfo(element);
        })
        return buffer;
      })
      .then(buffer => {
        //now get the user info after they are in there
        setTimeout(() => {
          buffer[0].map(element => {
            var animal = this.state[element];
            var userId = animal.userId;
            this.getUserInfo(userId);
          })
        }
          , 2000
        )
        return buffer[1]; //return original modified snapshot
      })
      .then(buffer => {
        //now parse the final packet and return it to be stored away
        setTimeout(() => {
          buffer.forEach(element => {
            //make temporary data buffer that we can maniuplate the data with
            dataDoc = element;
            //now grab animal name
            var animalName = this.state[element.animalId].name;
            var validScan = (element.invalidRequirements.length===0 && element.missingRequirements.length===0) ? "Yes" : "No";
            var ownerId = this.state[element.animalId].userId;
            var ownerName = this.state[ownerId].name;
            var ownerPhone = this.state[ownerId].phone;
            var latitude = element.latitude;
            var longitude = element.longitude;
            dataDoc = { ...dataDoc, ...{ name: animalName }, ...{ validForBusiness: validScan }, ...{ owner: ownerName }, ...{ phone: ownerPhone }, ...{ latitude: latitude }, ...{ longitude: longitude }};
            finalResult.push(dataDoc);
          });
        }
          , 3000
        )
        return finalResult;
      })
      .then((finalResult) => {
        setTimeout(() => {
          this.setState({ 
            scanInfo: finalResult,
            scanInfoLoading: false,
          })
        }, 4000)
      })
      .catch(err => {
        console.log('Error getting documents', err);
      });

  }


  onHandleChange(e) {
    var value = e.target.value;
    var name = e.target.name;
    var businessName;
    var subArray;
    var x;
    var busArray = this.state.business; 


    if(name==="businessSelect"){
      for(x=0; x<busArray.length; x++){
        subArray = busArray[x];
        if(subArray[0]===value){
          businessName = subArray[1];
        }
      }

      this.setState({
        businessId: value,
        businessName: businessName,
      })

    }else{
      this.setState({
        [name]: value,
        invalidPassword: false,
      })
    }
  }

  onProfileHandleChange(e) {
    let name = e.target.name;
    this.setState({
      profileInfo: {
        ...this.state.profileInfo,
        [name]: e.target.value
      }
    })
  }
  onAnimalProfileHandleChange(e) {
    let name = e.target.name;
    this.setState({
        [this.state.animalToEdit]:{
        ...this.state[this.state.animalToEdit],
         [name]: e.target.value,
        },
        changeLog: {...this.state.changeLog, [name]: e.target.value}
      })
  }
  onBusinessProfileHandleChange(e) {
    let name = e.target.name;
    this.setState({
      businessInfo: {
        ...this.state.businessInfo,
        [name]: e.target.value
      }
    })
  }

  uploadFecalExamCertificate(animalID) {

    var storageRef = firebase.storage().ref();
    var db = firebase.firestore();
    var uploadDate = Date.now();
    var fileID = `${animalID}_${uploadDate}`;
    
    var fileType = 'pdf';
    var fecalExam = this.state.fecalExamCertificate;
    if ((fecalExam === null) || (fecalExam===[]) || (fecalExam===undefined)) {
      return;
    } else {
      if(fecalExam.type.includes('image')){
        if(fecalExam.type.includes('png')){
          fileType = 'png';
        }
        else{
          fileType = 'jpeg';
        }
      }
       else{
        fileType = 'pdf';
      }

      const uploadTask = storageRef.child(`fecalExam/${fileID}`).put(fecalExam); //create a child directory called images, and place the file inside this directory
      uploadTask.on('state_changed', (snapshot) => {
        // Observe state change events such as progress, pause, and resume
      }, (error) => {
        // Handle unsuccessful uploads
      }, () => {
        // Do something once upload is complete
        uploadTask.snapshot.ref.getDownloadURL().then(function (downloadURL) {
          db.collection('animals').doc(animalID).collection('documents').doc(fileID).set({
            comment: "",
            documentType: "certificate",
            filePath: downloadURL,
            fileType: fileType,
            id: fileID,
            lastServiceDate: 0,
            serviceComment: '',
            serviced: false,
            servicedBy: "VERFID",
            status: "initial upload",
            type: "fecalExam",
            uploadDate: uploadDate
          }, {
              merge: true
            });
        });
      });
    }
   
  }

  paidSuccessfully() {
    alert('Thank you for ordering additional smart tags! They will be mailed in 5 to 7 business days.')
    this.setState(
      {
        animalToAddTagsFor: 0,
      }
    )
  }

  directPaymentToBusiness() {
    alert('We have received your payment! \nThe business will receive notification of your payment in 1-3 business days.\nA receipt will be emailed to your email on file.')
    var dateNow = Date.now();
    firebase.firestore().collection('activityLog').doc(`${dateNow}`).set({price: this.state.priceToPay, time:dateNow, user:this.state.profileInfo.userId, name:`${this.state.profileInfo.firstName} ${this.state.profileInfo.lastName}`, email:this.state.profileInfo.email, phone:this.state.profileInfo.phoneNumberPrimary , comments:this.state.businessPaymentsComments, business:this.state.businessId, businessName:this.state.businessName, type:"payment"});
    
  }

  directVerificationRequest() {
    var dateNow = Date.now();
    firebase.firestore().collection('directVerificationRequest').doc(`${dateNow}`).set({user:this.state.profileInfo.userId,business:this.state.businessId,businessName:this.state.businessName, type:"directRequest" }
    , function(error) {
      if (error) {
      } else {
      }
    });
    alert('Your request to be verified has been received. \nYou will be notified of the results within 1-2 business days.')
  }


  executeScript(){
    /*firebase.firestore().collection('animals').where('userId', '==', `mosWwX1dwVNYcEBXHuHDSeLW5wg2`).limit(25).get()
    .then(snapshot=>{
    snapshot.forEach(doc => {
      firebase.firestore().collection('animals').doc(`${doc.data().animalId}`).update({verified: false});
    })
  })*/
 }

  render() {
    return (
      <div>
        {(this.state.isSignedIn && !this.state.invalidProfile) ?
          <Media className="sub80">
                 {
                this.state.userProfile.displayName === 'Business' ?
                <Media>
                    <Media object src={this.state.businessImage}
                      alt="Generic placeholder image"
                      className="circleProfile" />
                  </Media> :
                  null
                 }
          <Media body>
              {this.state.userProfile.displayName === 'Business' ?
                <ListGroup >
                  {
                    !this.state.isBusinessProfileEditing ?
                      <Tabs className="sub70">
                        <ListGroup>
                          <TabList>
                            <Tab>Info</Tab>
                            <Tab>Scans</Tab>
                            <Tab>Payments</Tab>
                          </TabList>
                          <TabPanel  className="sub50">
                          {this.state.pageLoading?  
                            <div className="CenterImage">  <BarLoader sizeUnit={"px"} size={100} color={'#251F5F'} loading={true}/> </div>:
                                  <div>
                                    <br />
                                    <h1>{this.state.businessInfo.name}</h1>
                                    <br/>
                                    <h4>Email</h4>
                                    <label>{this.state.businessInfo.email}</label>
                                    <h4>Public Email</h4>
                                    <label>{this.state.businessInfo.emailPublic}</label>
                                    <h4>Phone</h4>
                                    <label>{this.state.businessInfo.phoneNumberPrimary}</label>
                                    <h4>Website</h4>
                                    <label>{this.state.businessInfo.website}</label>
                                    <h4>Business Address</h4>
                                    <label>{this.state.businessInfo.address.line1}</label>
                                    {this.state.businessInfo.address.line2 === '' ? null : <label>{this.state.businessInfo.address.line2}</label>}
                                    <br/>
                                    <label>{this.state.businessInfo.address.city}, {this.state.businessInfo.address.state} {this.state.businessInfo.address.zip}</label>
                                    <h4>Mobile App Pin</h4>
                                    <label>{this.state.businessInfo.pin}</label>
                                  </div>
                                  }
    
                            <br/>

                            {this.state.pageLoading? null:
                            <div>
                            <hr style={{                                
                                            height: 2,
                                            width:'60%',
                                            minWidth: '200px',
                                            maxWidth: '350px', 
                                            margin: 'auto'}}/>  
                            <h2>Canine Requirements</h2> 
                            <br/>
                            <h5>Canines Allowed</h5>
                            <label>{this.state.canineRequirements.restricted?"No":"Yes"}</label>
                            <h5>Maximum Weight</h5>
                            <label>{this.state.canineRequirements.maximumWeight===999?"No Limit":`${this.state.canineRequirements.maximumWeight}lbs`}</label>
                            <h5>Minimum Age</h5>
                               <label>{this.state.canineRequirements.minimumMonthsOfAge}{" Months"}</label>
                            <h5>Minimum Time Of Ownership</h5>
                            <label>{this.state.canineRequirements.minimumMonthsOfOwnership}{" Months"}</label>
                            <h5>Restricted Breeds</h5>
                            {
                              this.state.canineRequirements.restrictedBreeds.length===0?"None":
                              this.state.canineRequirements.restrictedBreeds.map((breeds)=>
                              {
                              return (<div><label>{breeds}</label><br/></div>)
                              })
                            }
                            <h5>Certificates</h5>
                            {
                              this.state.canineRequirements.certificates.length===0?"None":
                              this.state.canineRequirements.certificates.map((certs)=>
                              {
                              return (<div><label>{this.state.canineCerts[certs].name}</label><br/></div>)
                              })
                            }
                            <h5>Forms</h5>
                            {
                              this.state.canineRequirements.forms.length===0?"None":
                              this.state.canineRequirements.forms.map((forms)=>
                              {
                              return (<div><label>{this.state.canineForms[forms].name}</label><br/></div>)
                              })
                            }
                            <h5>Vaccines</h5>
                            {
                              this.state.canineRequirements.vaccinations.length===0?"None":
                              this.state.canineRequirements.vaccinations.map((vaccinations)=>
                              {
                              return (<div><label>{this.state.canineVacs[vaccinations].name}</label><br/></div>)
                              })
                            }
                            <br/>
                            <hr style={{height: 2, width:'60%', minWidth: '200px', maxWidth: '350px'}}/>  
                            <h2>Feline Requirements</h2>
                            <br/>
                            <h5>Felines Allowed</h5>
                            <label>{this.state.felineRequirements.restricted?"No":"Yes"}</label>
                            <h5>Maximum Weight</h5>
                            <label>{this.state.felineRequirements.maximumWeight===999?"No Limit":`${this.state.felineRequirements.maximumWeight}lbs`}</label>
                            <h5>Minimum Age</h5>
                            <label>{this.state.felineRequirements.minimumMonthsOfAge}{" Months"}</label>
                            <h5>Minimum Time Of Ownership</h5>
                            <label>{this.state.felineRequirements.minimumMonthsOfOwnership}{" Months"}</label>
                            <h5>Restricted Breeds</h5>
                            {
                              this.state.felineRequirements.restrictedBreeds.length===0?"None":
                              this.state.felineRequirements.restrictedBreeds.map((breeds)=>
                              {
                              return (<div><label>{breeds}</label><br/></div>)
                              })
                            }
                            <h5>Certificates</h5>
                            {
                              this.state.felineRequirements.certificates.length===0?"None" :
                              this.state.felineRequirements.certificates.map((certs)=>
                              {
                              return (<div><label>{this.state.felineCerts[certs].name}</label><br/></div>)
                              })
                            }
                            <h5>Forms</h5>
                            {
                              this.state.felineRequirements.forms.length===0?"None":
                              this.state.felineRequirements.forms.map((forms)=>
                              {
                              return (<div><label>{this.state.felineForms[forms].name}</label><br/></div>)
                              })
                            }
                            <h5>Vaccines</h5>
                            {
                              this.state.felineRequirements.vaccinations.length===0?"None":
                              this.state.felineRequirements.vaccinations.map((vaccinations)=>
                              {
                              return (<div><label>{this.state.felineVacs[vaccinations].name}</label><br/></div>)
                              })
                            }
                            </div>//end page loading
                              }

                          </TabPanel>
                        </ListGroup>
                        <TabPanel>
                          {(this.state.scanInfo === null || this.state.scanInfo === {} || this.state.scanInfo === undefined || this.state.scanInfoLoading) ? 
                          <div className="CenterImage"> { this.state.scanInfoLoading?  
                             <BarLoader sizeUnit={"px"} size={100} color={'#251F5F'} loading={true}/>
                            :<div></div>
                            } 
                          </div> :

                            <div>
                              <br></br>
                              <ReactTable data={this.state.scanInfo} columns={columns} />
                              <ExcelFile filename={'VERFID_Scan_Log'} element={<button id="getEventsButton">Download Data</button>}>
                                <ExcelSheet data={this.state.scanInfo} name='DataSet1'>
                                <ExcelColumn label="Time" value="scanDate"/>
                                  <ExcelColumn label="Name" value="name" />
                                  <ExcelColumn label="Action" value="eventType" />
                                  <ExcelColumn label="Notes" value="comment" />
                                  <ExcelColumn label="Valid" value="validForBusiness" />
                                  <ExcelColumn label="Owner" value="owner" />
                                  <ExcelColumn label="Phone" value="phone" />
                                  <ExcelColumn label="Latitude" value="latitude" />
                                  <ExcelColumn label="Longitude" value="longitude" />
                                </ExcelSheet>
                              </ExcelFile>
                              <br/><br/>
                            </div>
                          }
                          <div>
                          <h3>Start Date</h3>
                          <FormGroup style={{ display: 'flex', margin: 'auto', width: '50%', maxWidth:'180px', flexDirection: 'row', justifyContent: 'center', alignSelf: 'center' }}>
                          <Input type="date" name="startDate" defaultValue={this.state.startDate} onChange={this.onHandleChange} />
                          </FormGroup>
                          <h3>End Date</h3>
                          <FormGroup style={{ display: 'flex', maxWidth:'180px', flexDirection: 'row',margin: 'auto', width: '50%', justifyContent: 'center', alignSelf: 'center' }}>
                          <Input type="date" name="endDate" defaultValue={this.state.endDate} onChange={this.onHandleChange} />
                          </FormGroup>
                          <button id="getEventsButton" onClick={() => this.getScanInformation()}>Get Events</button>
                          </div>
                        </TabPanel>
                        <TabPanel>
                        <ReactTable data={this.state.businessPaymentLog} columns={paymentColumns} />
                        <ExcelFile filename={'VERFID_Payment_Log'} element={<button id="getEventsButton">Download Data</button>}>
                                <ExcelSheet data={this.state.businessPaymentLog} name='DataSet1'>
                                  <ExcelColumn label="Time" value="readableTime" />
                                  <ExcelColumn label="From" value="name" />
                                  <ExcelColumn label="Price" value="price" />
                                  <ExcelColumn label="Comments" value="comments" />
                                  <ExcelColumn label="Email" value="email" />
                                  <ExcelColumn label="Phone" value="phone" />
                                </ExcelSheet>
                              </ExcelFile>
                        </TabPanel>
                      </Tabs>                    
                      :
                      <ListGroup>
                        <BusinessStep2 {...this.state.businessInfo} editForm onHandleChange={this.onBusinessProfileHandleChange} handleProfileUpload={this.handleProfileUploadCompression} />
                        <br />
                        Please notify us if you would like to change your business access requirements.
                        <br />

                      </ListGroup>
                  }
                  {/* <button onClick={() => this.state.isBusinessProfileEditing ? this.updateBusinessProfile() : this.toggleBusinessProfileEditing()} >{this.state.isBusinessProfileEditing ? 'Save' : 'Edit'}</button>*/}
                </ListGroup>
                :
                <ListGroup>
                  <Tabs>
                    <TabList>
                      <Tab>Owner</Tab>
                      <Tab>Pets</Tab>
                      <Tab>Business</Tab>
                      <Tab>Activity</Tab>
                      <Tab>Admin</Tab>
                    </TabList>
                    <TabPanel>
                      <Media>
                        <Media object src={this.state.profileImage}
                          alt="Generic placeholder image"
                          className="circleProfile" />
                      </Media>
                  {
                    !this.state.isProfileEditingUser ?
                      <div id="loginBlock">
                          {
                            this.state.isLoadingAnimalInfo? 
                            
                            <div>
                            <h5>Getting profile information</h5>
                            <br/>
                            <div className="CenterImage">
                            <BarLoader sizeUnit={"px"} size={100} color={'#251F5F'} loading={true}/>

                            </div> 
                                                        </div>:
                            <div>
                               {/* <button onClick={()=>this.executeScript()}>make changes</button> */}
                                <h3>{this.state.profileInfo.firstName}{" "}{this.state.profileInfo.lastName}</h3>
                                 <b>Email:</b> {this.state.profileInfo.email}<br/>
                                 <b>Phone:</b> {this.state.profileInfo.phoneNumberPrimary}<br/>
                                 <b>Address:</b> <br/> {this.state.profileInfo.address.line1}<br/>
                                 {this.state.profileInfo.address.line2 === '' ? null : <div>{this.state.profileInfo.address.line2}</div>}
                                 {this.state.profileInfo.address.city}, {this.state.profileInfo.address.state} {this.state.profileInfo.address.zip}
                                 <br/>
                            </div>
                          }
                      
                        {this.state.isProfileEditingUser ? null :
                     <p id="editProfileButton" onClick={() => this.state.isProfileEditingUser ? null : this.toggleProfileEditingUser(0)} >{(this.state.isProfileEditingUser || this.state.isLoadingAnimalInfo) ? null : <div>Edit Your Info</div>}</p>
                        }
                      </div>
                      :
                      <ListGroup>
                        <div id="loginBlock">
                        <Step2
                          {...this.state.profileInfo}
                          profilePictureBlob={this.state.profilePictureBlob}
                          editForm={true}
                          onHandleChange={this.onProfileHandleChange}
                          handleProfileUploadCompression={this.handleProfileUploadCompression}
                        />
                        </div>
                      </ListGroup>
                  }
                   {this.state.isProfileEditingUser ?
                    <button id="editProfileButton" onClick={() => this.updateProfileUser()}>Save</button>
                    : null
                  }
                  </TabPanel>
                  <TabPanel>
                   <ListGroup id="outerAnimalInfo">
                    {this.state.isProfileEditingAnimal ?
                      <ListGroup id="loginBlock">
                        <Step3
                          {...this.state[`${this.state.animalToEdit}`]}
                          editForm={true}
                          canineVacs={this.state.canineVacs}
                          felineVacs={this.state.felineVacs}
                          dogImageBlob={this.state.dogImageBlob}
                          removeVaccine = {this.removeVaccine}
                          onHandleChange={this.onAnimalProfileHandleChange}
                          handleProfileUploadCompression={this.handleProfileUploadCompression}
                          onHandleMultipleChange = {this.handleMultipleChange}
                        />
                      </ListGroup>
                      :
                      <div>
                        {
                         this.state.isLoadingAnimalInfo  ? 
                         <div>
                         <h5>Getting Profile Information</h5> 
                         <br/>
                         <div className="CenterImage">
                            <BarLoader sizeUnit={"px"} size={100} color={'#251F5F'} loading={true}/>
                            </div> 
                         </div>
                         :
                         !this.state.animalExists?
                         <h5>There are no animals associated with this account</h5> :

                         this.state.Animals.map((Animals) => {
                          const birthDate = new Date(this.state[Animals].birthDate).toDateString();
                          const ownedSinceDate = new Date(this.state[Animals].ownedSince).toDateString();
                          const vacs = this.state[Animals].species==='canine'?this.state.canineVacs:this.state.felineVacs;
                          const certs = this.state[Animals].species==='canine'?this.state.canineCerts:this.state.felineCerts;
                          const forms = this.state[Animals].species==='canine'?this.state.canineForms:this.state.felineForms;
                          const animalID = this.state[Animals].animalId;
                          return <div>
                            <br/>
                            <h3>{this.state[Animals].name}</h3>
                            <br/>
                            <Media object src={this.state[Animals].imageUrl}
                                        alt="Generic placeholder image"
                                        className="animalImage" />    
                                 <br/><br/> 
                                 <h4>General Info</h4>                       
                                 <b>Date of Birth:</b> {birthDate}<br/>
                                 <b>Date of Ownership:</b> {ownedSinceDate}<br/>
                                 <b>Fixed:</b> {this.state[Animals].fixed?"Yes":"No"}<br/>
                                 <b>Weight:</b> {this.state[Animals].weight}<br/>
                                 <b>Gender:</b> {this.state[Animals].gender}<br/>
                                 <b>Breed:</b> {this.state[Animals].breed}
                                 {(this.state[Animals].breed2==='' || this.state[Animals].breed2==='Not Applicable') ?null: <div>and {this.state[Animals].breed2}</div>}
                                 <br/>
                                 <b>Comments:</b> {this.state[Animals].comment}<br/>  
                                 <hr  style={{                                
                                            height: 2,
                                            width:'60%',
                                            minWidth: '300px',
                                            maxWidth: '350px'}}/>          
                                 <h4>Medical and Forms</h4>
                                 {              
                                 Object.keys(vacs).map((key)=>{
                                 return <div> 
                                   {
                                     //check if state exists
                                     (this.state[`${animalID}${key}`]==undefined)?
                                     null:
                                     <div>
                                       <br/>
                                       <b>{vacs[`${key}`].name}</b>
                                       <br/>
                                       <b>Expires:</b> {
                                         ((this.state[`${animalID}${key}`].expiration===undefined) || (this.state[`${animalID}${key}`].expiration===0))?
                                         <div> Not provided or not applicable </div>
                                         :<div>{(new Date(this.state[`${animalID}${key}`].expiration).toLocaleDateString())}</div>
                                       }
                                      <b>Status:</b> {this.state[`${animalID}${key}`].verified?<div style={{ color: '#30C047' }}>Verified</div>:<div style={{ color: 'red' }} >Not Verified</div>}
                                      </div> 
                                   }
                              </div>
                                 })
                                }
                                {              
                                 Object.keys(certs).map((key)=>{
                                 return <div> 
                                   {
                                     //check if state exists
                                     (this.state[`${animalID}${key}`]==undefined)?
                                     null:
                                     <div>
                                       <br/>
                                       <b>{certs[`${key}`].name}</b>
                                       <br/>
                                       <b>Expires:</b> {
                                         ((this.state[`${animalID}${key}`].expiration===undefined) || (this.state[`${animalID}${key}`].expiration===0))?
                                         <div> Not provided or not applicable </div>
                                         :<div>{(new Date(this.state[`${animalID}${key}`].expiration).toLocaleDateString())}</div>
                                       }
                                      <b>Status:</b> {this.state[`${animalID}${key}`].verified?<div style={{ color: '#30C047' }}>Verified</div>:<div style={{ color: 'red' }} >Not Verified</div>}
                                      </div> 
                                   }
                              </div>
                                 })
                                }

                              {
                                 Object.keys(forms).map((key)=>{
                                 return <div> 
                                   {
                                     //check if state exists
                                     (this.state[`${animalID}${key}`]==undefined)?
                                     null:
                                     <div>
                                       <br/>
                                       <b>{forms[`${key}`].name}</b>
                                       <br/>
                                      <b>Status:</b> {this.state[`${animalID}${key}`].verified?<div style={{ color: '#30C047' }}>Verified</div>:<div style={{ color: 'red' }} >Not Verified</div>}
                                      </div> 
                                   }
                              </div>
                                 })
                                }

                                  <div id="loginBlock">
                                    <hr  style={{                                
                                            height: 2,
                                            width:'60%',
                                            minWidth: '300px',
                                            maxWidth: '350px'}}/>  
                                    <h4>Uploaded Documents</h4>
                                      
                                    {
                                    this.state[`${animalID}DocNum`] === 0 ? "No recorded documents":
                                    Object.keys(this.state[`${animalID}DocsToView`]).map((key)=>{
                                      return <div> 
                                        { 
                                          <div>
                                              <a target="_blank" href={this.state[`${animalID}DocsToView`][key].filePath}>{this.state[`${animalID}DocsToView`][key].type + " : " + this.state[`${animalID}DocsToView`][0].uploadDate}</a>
                                              <br/>                
                                          </div> 
                                        }
                                    </div>
                                      })

                                }
                                    </div>

                                    <div id="loginBlock">
                                    <hr  style={{                                
                                            height: 2,
                                            width:'60%',
                                            minWidth: '300px',
                                            maxWidth: '350px'}}/>  
                                    <h4>Profile Management</h4>
                                    {this.state.isProfileEditingAnimal ? null :
                                      <label id="editProfileButton" onClick={() => this.toggleProfileEditingAnimal(animalID)} >{<div>Edit {this.state[Animals].name}</div>}</label>
                                    }
                                    <br/>
                                    {this.state.isProfileEditingAnimal ? null :
                                      <label id="editProfileButton" onClick={() => this.orderNewtag(animalID)}>Purchase another tag for {this.state[Animals].name} </label>
                                    }

                                    {
                                      this.state.animalToAddTagsFor === animalID ?
                                        <div>
                                          <FormGroup>
                                            <br />
                                            <h5> How many tags do you want to order? </h5>
                                            <Input type="number" name="numberOfTags" id="numberOfTags" maxLength="2" max="10" min="0" placeholder="1*" defaultValue={1} onChange={this.setNumTags} />
                                          </FormGroup>
                                          <br />
                                          <h5>Tag Price (with shipping): ${(695 * this.state.numberOfTags / 100).toFixed(2)}</h5>
                                          <br />
                                          <Checkout
                                            amount={695 * this.state.numberOfTags}
                                            userId={this.state.userProfile.userId}
                                            email={this.state.userProfile.email}
                                            description={'Order of additional VERFID tags'}
                                            onSuccess={() => this.paidSuccessfully()}
                                          />
                                          <br />
                                          <br />

                                        </div>
                                        :
                                        null
                                    }

                                    </div>
                                    <br/>
                                    {(this.state.animalToAddTagsFor === animalID) ? null :
                                      <div>
                                        {
                                        (this.state[Animals].transfer && this.state[Animals].transfer===true) ?
                                        <div style={{ color: 'red' }}> 
                                        You have requested your pet to be transferred <br/>
                                        Transfer code: {animalID} <br/>
                                        <label id="undoTransferPet" onClick={() => this.transferPet(this.state[Animals].name, animalID, false)} >Undo Transfer Request</label>
                                        </div>:
                                        <label id="transferPet" onClick={() => this.transferPet(this.state[Animals].name, animalID, true)} >Transfer Pet</label>
                                        }
                                      </div>
                                    }
                                
                                  <hr  style={{
                                            backgroundColor: '#251F5F',
                                            height: 5,
                                            width:'60%',
                                            minWidth: '300px',
                                            maxWidth: '350px'}}/>
                                 <br/>
                                 </div>
                            }) }</div>
                    }                 
                  </ListGroup>
                  {this.state.isProfileEditingAnimal ?
                    <label id="editProfileButton" onClick={() => this.state.isProfileEditingAnimal ? this.updateProfileAnimal() : null} >{this.state.isProfileEditingAnimal ? 'Save' : null}</label>
                    : null
                  }
                  </TabPanel>
                  <TabPanel>

                    <br/>
                    <FormGroup>
                    <h5>Select Action</h5>
                    <div id="loginBlock"> 
                    <Input type="select" name="businessTabSetting" onChange={this.onHandleChange}>
                      <option value='payment'>Direct Payment</option>
                      <option value='directlyVerify'>Directly Verify</option>
                    </Input>
                    </div>
                  </FormGroup>

                  {
                    this.state.businessTabSetting === "directlyVerify"? 
                    <div id="loginBlock"> 
                    <h5>Business To Directly Verify With</h5>
                    <Input type="select" name="businessSelect" id="businessSelect" onChange={this.onHandleChange}>
                    {
                    this.state.business.map((business) => {
                    return <option value={business[0]}>{business[1]}</option>
                      }) 
                    }
                  </Input>
                  <br/>
                  <Button onClick={()=>this.directVerificationRequest()}>Request Verification</Button>
                  </div>:
                  <div>
                  <br/>
                  {this.state.isLoadingAnimalInfo? <h5>Loading business info</h5>:
                  <div>
                    <h5>Business To Pay</h5>
                    <div id="loginBlock"> 
                    <Input type="select" name="businessSelect" id="businessSelect" onChange={this.onHandleChange}>
                    {
                    this.state.business.map((business) => {
                    return <option value={business[0]}>{business[1]}</option>
                      }) 
                    }
                  </Input>
                  <br/>
                  <h5 onClick={()=>alert('Please use the memo section to let us know what the payment is for.')}>Comments {'\u24d8'}</h5>
                    <FormGroup>
                    <Input type="textarea" name="businessPaymentsComments" rows="4" placeholder="Memo to the business" defaultValue={""} onChange={this.onHandleChange} />
                  </FormGroup>
                  <br/>
                  <h5 onClick={()=>alert('Sometimes special circumstances change the amount owed. As an example, some animal licensing fees are discounted for senior citizens, military service members, or town employees. \n\nPlease use the document upload to provide supporting information, if this applies to you.')}>File Upload {'\u24d8'}</h5>
                  <input type="file" name="supportingDocs" id="supportingDocs" accept=".jpg, .png, .pdf" onChange={this.onHandleChange} />
                  <br/>
                  <br/>
                  <h5>Amount To Pay</h5>
                  <Input type="number" name="priceToPay" id="priceToPay" maxLength="8" min="0" placeholder="30.00" defaultValue={31.95} onChange={this.onHandleChange}/>
                  <br/>
                  <Checkout
                    amount={100 * this.state.priceToPay}
                    userId={this.state.profileInfo.userId}
                    email={this.state.profileInfo.email}
                    description={'Direct Payment To Business'}
                    onSuccess={() => this.directPaymentToBusiness()}
                  />
                   </div>
                   </div>}
                   </div>
                  }
                  </TabPanel>
                  <TabPanel>
                    {
                      (this.state.activityLog===[] || !this.state.animalExists)? 
                      <h5>You have no recorded activity</h5>:
                      <div>
                        {
                          this.state.activityLog===undefined?null:
                        Object.keys(this.state.activityLog).map((key)=>{
                          const data = this.state.activityLog[key];
                          const eventType = data[1].type;
                                 return <div> 
                                   {
                                     eventType==="payment"?
                                   <div> <h5>Payment</h5><label>{(new Date(parseInt(data[0],10)).toLocaleDateString())} to {data[1].businessName} for ${data[1].price} </label></div>:
                                   <div> <h5>Profile Update</h5> <label>{data[1].animalName} {(new Date(parseInt(data[0],10)).toLocaleDateString())} </label></div>
                                   }
                              </div>
                                 })
                        }
                      </div>
                    }
                  </TabPanel>
                  <TabPanel>
                  <div id="loginBlock">
                  <h5>Claim Animal</h5>
                  <FormGroup>
                  <Input type="text" name="animalNameRequested" id="animalNameRequested" placeholder="Animal Name" onChange={this.onHandleChange} /> 
                   <Input type="text" name="animalIdRequested" id="animalIdRequested" placeholder="Animal Transfer Code" onChange={this.onHandleChange} /> 
                  </FormGroup>
                  <button id="requestAnimal" onClick={() => this.requestAnimal(this.state.animalNameRequested, this.state.animalIdRequested)}>Request Animal</button>
                  </div>
                  </TabPanel>
                  </Tabs>
                </ListGroup>
              }
            </Media>
          </Media>
          : 
          <div className="sub50" >
            {
              this.state.pageLoading? 
              <div>
                Loading 
                <br/>
                <div className="CenterImage">
                <BarLoader sizeUnit={"px"} size={100} color={'#251F5F'} loading={true}/>
                </div> 
              </div>
              :
            <div>
              {
                this.state.invalidProfile? <div>
                Woops it looks like you didn't finish creating your account
                <br/>
                <a href="/">Click here to continue creating your account.</a>
                </div>
                :
                <h5>You were logged out of your account.</h5> 
              }
              </div>
            } 
          </div>
        }
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/Profile.js